import { CropYear, ICrop, IField } from "../../omnia"

interface Context {

    field: IField

    crop: ICrop

    area: number
    getUsableArea(): number

    cropYear: CropYear
    startDate: Date
    endDate: Date
    dateErrors: { [key: string]: string }

}

export function getCroppingErrorMessages(vm: Context) {

    return {

        // <ng-message when="SowingDate/date">Invalid sowing date: it must be earlier than {{vm.endDate | date:"dd/MM/yyyy"}}</ng-message>
        "dates/SowingDate/date": () => `Invalid sowing date: it must be earlier than ${date(vm.endDate)}`,

        // <ng-message when="HarvestDate/date">Invalid harvest date: it must be later than {{vm.startDate | date:"dd/MM/yyyy"}}</ng-message>
        "dates/HarvestDate/date": () => `Invalid harvest date: it must be earlier than ${date(vm.startDate)}`,

        // <ng-message when="DestructionDate/date">Invalid destruction date: it must be later than {{vm.startDate | date:"dd/MM/yyyy"}}</ng-message>
        "dates/DestructionDate/date": () => `Invalid destruction date: it must be later than ${date(vm.startDate)}`,

        // <ng-message when="year">Either the sowing date or the {{vm.getEndDateName()}} date must be set in the crop's year ({{vm.cropYear.StartDate | date:"dd/MM/yyyy"}} to {{vm.cropYear.EndDate | date:"dd/MM/yyyy"}})</ng-message>
        "dates/year": () => `Either the start date or the end date must be set in the crop's year (${date(vm.cropYear.StartDate)} to ${date(vm.cropYear.EndDate)})`,

        // <ng-message when="twoyears">The crop should span at most two cropping years</ng-message>
        "dates/twoyears": () => "The crop should span at most two cropping years",

        // <ng-message when="Start/PerennialCroppingYear">Invalid sowing date: this cropping year has not been opened on the current holding</ng-message>
        "dates/Start/PerennialCroppingYear": () => "Invalid sowing date: this cropping year has not been opened on the current holding",

        // <ng-message when="End/PerennialCroppingYear">Invalid destruction date: this cropping year has not been opened on the current holding</ng-message>
        "dates/End/PerennialCroppingYear": () => "Invalid destruction date: this cropping year has not been opened on the current holding",

        // <ng-message when="DestructionDate/AfterNextYear">Invalid destruction date: must be before the end of the next cropping year</ng-message>
        "dates/End/DestructionDate/AfterNextYear": () => "Invalid destruction date: must be before the end of the next cropping year",

        // <ng-message when="Concurrent" ng-bind-html="vm.dateErrors.Concurrent"></ng-message>
        "dates/Concurrent": () => vm.dateErrors.Concurrent,

        "Area/area": () => `Invalid area: it cannot be null, and must be at the most ${vm.getUsableArea()} ha`,
        "Area/manure-area": () => `Invalid manure area: it cannot be null, and must be at the most ${vm.area} ha`,

        "ManureSpreadArea/area": () => `Invalid manure spreadable area: it cannot be higher than the cropping area (${vm.area}\u00A0ha)`,
        "ManureSpreadArea/field": () => `Invalid manure spreadable area: it cannot be higher that the manure spreable area for the field (${vm.field.ManureSpreadArea}\u00A0ha)`,

        "TargetYield/min": () => `The minimun yield is ${vm.crop?.TargetYieldMin}\u00A0t/ha`,
        "TargetYield/max": () => `The maximum yield is ${vm.crop?.TargetYieldMax}\u00A0t/ha`,
        "TargetYield/required": () => `The yield is required`,

        "ActualYield/min": () => `The minimun yield is ${vm.crop?.TargetYieldMin}\u00A0t/ha`,
        "ActualYield/max": () => `The maximum yield is ${vm.crop?.TargetYieldMax}\u00A0t/ha`

    }

    function date(date: Date) {
        return date.toLocaleDateString(undefined, { day: "2-digit", month: "2-digit", year: "numeric" })
    }
}
